export const ANALYTICS_CATEGORIES = {
  login: 'ReduxLogin',
  product: 'ReduxProduct',
  rightsRequests: 'ReduxRightsRequests',
  share: 'ReduxShare',
} as const;

export const ANALYTICS_ACTIONS = {
  loginSubmitting: 'LOGIN_SUBMITTING',
  loginSuccess: 'LOGIN_SUCCESS',
  loginFailed: 'LOGIN_FAILED',
  logout: 'LOGOUT',
  productsLoaded: 'PRODUCT.SET_PRODUCTS',
  rightsTemplateLanguageChanged: 'RIGHTS_REQUESTS.SET_RIGHTSTEMPLATE_FR',
  rightsTemplateSelected: 'RIGHTS_REQUESTS.SET_SELECTED_TEMPLATE',
  publishing: 'PUBLISHING',
  publishFailed: 'PUBLISH_FAILED',
} as const;

/** Track an event only when the authenticated GA client is available. */
export function trackAnalyticsEvent(action: string, category: string): void {
  window.analytics?.trackEvent(action, category);
}
